import axios from "axios";
import { API_URL } from '../api.js'

const apiUser = `${API_URL}/users`;
const apiRestaurant = `${API_URL}/restaurant`

export default {
  async getUser() {
    const resp = await axios.get(`${apiUser}`);
    return resp.data;
  },
  async editUserInfo(info) {
    const resp = await axios.post(`${apiUser}/editinfo`, { info });
    return resp.data;
  },
  async getRestaurant(restaurantId) {
    const resp = await axios.get(`${apiRestaurant}/${restaurantId}`);
    return resp.data;
  },
  async editOnlineOrdering(restaurantId, status, automaticIsOpen, allowPreorderingWhenClosed, orderScheduling, times, minimalOrderValue, deliveryOptions, paymentOptions, ordersNotificationEmail) {
    const resp = await axios.post(`${apiRestaurant}/editonlineordering`, { restaurantId, status, automaticIsOpen, allowPreorderingWhenClosed, orderScheduling, times, minimalOrderValue, deliveryOptions, paymentOptions, ordersNotificationEmail });
    return resp.data;
  },
  async connectStripe(restaurantId) {
    const resp = await axios.post(`${apiRestaurant}/connectstripe`, { restaurantId });
    return resp.data;
  },
  async generatePortosToken(restaurantId) {
    const resp = await axios.post(`${apiRestaurant}/generateportostoken`, { restaurantId });
    return resp.data;
  },
  async editBusinessDetails(restaurantId, businessDetails) {
    const resp = await axios.post(`${apiRestaurant}/editbusinessdetails`, { restaurantId, businessDetails });
    return resp.data;
  },
  async editNames(restaurantId, names) {
    const resp = await axios.post(`${apiRestaurant}/editnames`, { restaurantId, names });
    return resp.data;
  },
  async editRestaurantInfo(restaurantId, info) {
    const resp = await axios.post(`${apiRestaurant}/editinfo`, { restaurantId, info });
    return resp.data;
  },
  async editDefaultMessages(restaurantId, defaultMessages) {
    const resp = await axios.post(`${apiRestaurant}/editdefaultmessages`, { restaurantId, defaultMessages });
    return resp.data;
  },
  async editCustomHeadings(restaurantId, customHeadings) {
    const resp = await axios.post(`${apiRestaurant}/editcustomheadings`, { restaurantId, customHeadings });
    return resp.data;
  },
  async addAccess(restaurantId, access) {
    const resp = await axios.post(`${apiRestaurant}/addaccess`, {
      restaurantId,
      access
    });
    return resp.data;
  },
  async editAccess(restaurantId, access) {
    const resp = await axios.post(`${apiRestaurant}/editaccess`, {
      restaurantId,
      access
    });
    return resp.data;
  },
  async removeAccess(restaurantId, accessId) {
    const resp = await axios.post(`${apiRestaurant}/removeaccess`, {
      restaurantId,
      accessId
    });
    return resp.data;
  },
};
